import Vue from 'vue';
import './index.view.scss';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import 'root/common/util/Stat.js';
import appDownload from 'root/blackcard/components/appDownload/index';
import { getAdvertiseBySuperMarket, getAdvertiseBannerBySuperMarket } from 'root/common/modules/advertise';
import { getSuperMarketQueryOrderUrl, getSuperMarketUnionLoginUrl } from './modules/index';
import shareBtn from 'root/common/components/shareBtn';
import { getQueryFromQuery } from 'root/common/util/url';
import storage from 'root/common/util/storage';
import { gioEvariableTrackOfPrivilege } from 'root/common/gio/tqGio';
import locationUtil from 'root/blackcard/util/location/locationUtil.js';

// import { OrderListGrayScale } from '@/common/util/privilege';
// OrderListGrayScale.init();

// const ZZCFL = window.ZZCFL;
Vue.use(VueAwesomeSwiper);
const vm = new Vue({
    el: '#app',
    delimiters: ['{%', '%}'],
    data() {
        const self = this;
        return {
            superMarketList: [],
            modules: [],
            swiperData: [],
            unload: false,
            supermarketListBanner: {},
            supermarketListButton: {},
            swiperOption: {
                loop: true,
                spaceBetween: 0,
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
                initialSlide: 0,
                // speed: 1000,
                watchOverflow: true,
                pagination: {
                    el: '.swiper-pagination',
                },
                on: {
                    transitionEnd: function() {
                        // self.page.cur = that.realIndex;
                    },
                    init: () => {
                        // 当banner只有一张时 销毁swiper
                        setTimeout(() => {
                            if (self.$refs.mySwiper.swiper && self.swiperData && self.swiperData?.length <= 1) {
                                self.$refs.mySwiper.swiper.destroy(false);
                                self.unload = true;
                            }
                        }, 500);
                    },
                    click: function() {
                        // 这里有坑
                        // 需要注意的是：this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法
                        // console.log(this); // -> Swiper
                        // 当前活动块的索引，与activeIndex不同的是，在loop模式下不会将 复制的块 的数量计算在内。
                        // const realIndex = this.realIndex;
                        // self.clickBanner(self.swiperData[realIndex]);
                    },
                },
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
            },
        };
    },
    async created() {
        if (!getQueryFromQuery(location.search).shareHash) {
            storage.remove('shareHash');
        }

        this.getSuperMarketBanner();
        this.getSuperMarketList();
        // * GIO 浏览超市聚合页
        gioEvariableTrackOfPrivilege('marketPageView', { data: {} });
        // Pv统计
        window.bigTj.track('page_view', {
            obj_id: 'supermarket_list',
            obj_type: 'supermarket_list',
        });
    },
    computed: {
        footerStyle() {
            return {
                backgroundImage: `url(${this.supermarketListButton?.img})`,
            };
        },
    },
    components: { appDownload, shareBtn },
    methods: {
        async getSuperMarketList() {
            const cityId = (locationUtil.getChooseCityCache() || {}).id;
            const positionsKeys = ['supermarket', 'supermarket_list_banner', 'supermarket_list_button'];
            const result = await getAdvertiseBySuperMarket({ positions: positionsKeys.join(','), cityId });
            this.modules = result?.['supermarket'] || [];
            const supermarketListBanner = result?.['supermarket_list_banner'] || [];
            const supermarketListButton = result?.['supermarket_list_button'] || [];
            this.supermarketListBanner = supermarketListBanner[0] || {};
            this.supermarketListButton = supermarketListButton[0] || {};
        },

        async getSuperMarketBanner() {
            const cityId = (locationUtil.getChooseCityCache() || {}).id;
            const positionsKeys = 'supermarket_banner';
            const result = await getAdvertiseBannerBySuperMarket({ positions: positionsKeys, cityId });
            this.swiperData = result;
        },

        clickBannerUnload(item) {
            if (item && item.url) {
                location.href = item.url;
            }
        },

        /**
         * 超市链接跳转
         *
         * @date 2019-08-28
         */
        linkToSuperMarket(item, index) {
            // * GIO 点击超市聚合页
            gioEvariableTrackOfPrivilege('marketPageClick', {
                data: {
                    entrancePage_var: '尊享特权',
                    entrancePosition_var: '热门推荐',
                    marketID_var: item.businessId,
                    marketName_var: item.name,
                    position_var: String(index + 1),
                },
            });
            // Pv统计
            window.bigTj.track('page_view', {
                obj_id: 'supermarket',
                obj_type: 'supermarket_list',
                supermarket_name: item.name,
            });

            const shareHash = getQueryFromQuery(location.search).shareHash;
            setTimeout(() => {
                location.href = `${item.url}${shareHash ? `&shareHash=${shareHash}` : ''}`;
            }, 30);
        },
        //请求后端接口查询订单链接
        async handleGetOrderUrl() {
            return await getSuperMarketQueryOrderUrl();
        },
        //获取订单页面地址
        async linkToOrder() {
            const res = await this.handleGetOrderUrl();
            if (res.code === 0) {
                if (res.data && res.data.url) {
                    location.href = res.data.url;
                }
            } else {
                window.ZZCFL.Toast(res.msg);
            }
            // OrderListGrayScale.jumpOrderList('priv_supermarket', `${location.origin}/supermarket/redirect-query-order`);
        },
        async handleBtnJumpUrl() {
            const { code, data, msg } = await getSuperMarketUnionLoginUrl({
                supplierAlias: 'yinShang',
            });
            if (code !== 0) {
                window.ZZCFL.Toast(msg);
                return;
            }
            const { url = '' } = data;
            if (!url) return;
            window.location.href = url;
        },
        handleBannerJumpUrl() {
            this.handleBtnJumpUrl();
        },
    },
});

export default vm;
